var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.96798 4.16592C10.8536 2.61136 13.1464 2.61136 14.032 4.16592L21.7041 17.6324C22.5649 19.1433 21.4445 21 19.6721 21H4.32789C2.55546 21 1.4351 19.1433 2.29587 17.6324L9.96798 4.16592Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangle9);
export default __webpack_public_path__ + "static/media/triangle-9.6162ce734853e5abf6e267ba33dbcded.svg";
export { ForwardRef as ReactComponent };